import { Layers } from "lucide-react";

const money = (n) => `$${Number(n || 0).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const COLOR = { esencias: "chip-amber", perfumol: "chip-ink", envases: "chip-emerald", insumos: "" };

/** Vista Almacén Central: el pedido dividido por familia (esencias por proveedor aprendido, perfumol, envases, insumos). */
export default function DesgloseProveedores({ desglose }) {
  return (
    <div className="px-5 py-3 border-b border-brand-line/50" data-testid="desglose-proveedores">
      <div className="text-[10px] uppercase tracking-wider text-brand-muted font-bold flex items-center gap-1.5 mb-2"><Layers className="w-3.5 h-3.5 text-brand-amber" /> Preparación por familia y proveedor (vista Almacén Central)</div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-2">
        {desglose.grupos.map((g) => (
          <div key={g.titulo} className="rounded-xl border border-brand-line bg-white p-3" data-testid={`desglose-${g.familia}${g.proveedor ? `-${g.proveedor}` : ""}`}>
            <div className="flex items-center justify-between gap-2"><span className={`chip text-[10px] ${COLOR[g.familia]}`}>{g.titulo}</span><span className="font-mono text-xs text-brand-muted">{g.items.length} línea(s) · {money(g.importe)}</span></div>
            <ul className="mt-2 space-y-0.5">{g.items.map((i) => <li key={i.componente_id} className="text-xs flex justify-between gap-2"><span className="truncate text-brand-ink">{i.nombre}</span><span className={`font-mono shrink-0 ${i.faltante > 0 ? "text-rose-700 font-bold" : "text-brand-slate"}`}>{i.cantidad_enviada} {i.unidad}{i.faltante > 0 ? ` · faltan ${i.faltante}` : ""}</span></li>)}</ul>
          </div>
        ))}
      </div>
    </div>
  );
}
